/** Current zoom from the world layer's `--inv-zoom` (1 when unknown): world px = screen px × this. */
export function worldPerScreenPx(el: Element): number {
  const v = parseFloat(getComputedStyle(el).getPropertyValue('--inv-zoom'));
  return Number.isFinite(v) && v > 0 ? v : 1;
}
